export const validateUrl = (url: string, domain?: string) => {
  const regex = new RegExp(
    `(?:http(?:s)?:\\/\\/)?(?:www\\.)?${
      domain ?? '([a-zA-Z0-9@:%.\\-_\\+~#=]){2,256}'
    }\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)`
  );

  return regex.test(url);
};
